import React, { useMemo } from "react";
import { useRequest } from "ahooks";
import { api } from "@redux/api";
import { useAuth } from "@/hooks/use-auth";
import { Nopermission } from "@/components/Nopermission";
import { useNavigate } from "react-router-dom";
import { emitEvent } from "@/hooks/useEventBus";
import { useDispatch, useSelector } from "react-redux";
import appActions from "@redux/app/actions";
import { buildFacilityPath, getFacilityContext } from "@/utils/route-context";
import SwitchablePieChart from "./SwitchablePieChart";

const STATUS_COLORS = {
  "Completed": "#4ade80",
  "Verifying": "#60a5fa",
  "On-Hold": "#9ca3af",
  "InProgress": "#fb923c",
  "Not Started": "#ef4444",
};

const PRIORITY_COLORS = {
  "Urgent": "#ef4444",
  "Important": "#fb923c",
  "Low": "#4ade80",
};

const WorkorderChart = () => {
  const workorderPermission = useAuth("workorder", 1);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const facilityId = useSelector((state) => state?.Facility?.selected?.Id);
  const facilityContext = useSelector((state) => getFacilityContext(state));

  const { data: workorderData } = useRequest(
    () => api.allworkorderview(),
    {
      ready: workorderPermission,
      cacheKey: `workorder-combined-chart-data-${facilityId}`,
      staleTime: 1 * 60 * 1000,
    }
  );

  if (!workorderPermission) {
    return <Nopermission />;
  }

  const groupedStatusData = workorderData?.data?.grouped_status_data;
  const groupedPriorityData = workorderData?.data?.grouped_priority_data;

  if (!groupedStatusData && !groupedPriorityData) {
    return null;
  }

  const handleStatusClick = (e) => {
    emitEvent("CLOSE_WORKORDER");
    const url =
      buildFacilityPath("workorder", {
        ...facilityContext,
        query: { status: e.data.name },
      }) || "/switch-view";
    navigate(url);
    dispatch(appActions.changeCurrent(["workorder"]));
  };

  const handlePriorityClick = (e) => {
    emitEvent("CLOSE_WORKORDER");
    const url =
      buildFacilityPath("workorder", {
        ...facilityContext,
        query: { priority: e.data.name },
      }) || "/switch-view";
    navigate(url);
    dispatch(appActions.changeCurrent(["workorder"]));
  };

  const configs = [
    {
      key: "status",
      title: "Workorder By Status",
      label: "Status",
      data: groupedStatusData,
      colors: STATUS_COLORS,
      onClick: handleStatusClick,
    },
    {
      key: "priority",
      title: "Workorder By Priority",
      label: "Priority",
      data: groupedPriorityData,
      colors: PRIORITY_COLORS,
      onClick: handlePriorityClick,
    },
  ];

  return (
    <SwitchablePieChart configs={configs} defaultActiveKey="status" />
  );
};

export default WorkorderChart;
